export const ipfsUriToUrl = (ipfsUri:string) => {
    return `https://ipfs.io/ipfs/${ipfsUri.replace("ipfs://", "")}`
}